// The restaurant's chats in the platform agent's panel (D4). Wording from the Amigo design's copy sheet (Chats, Chats
// none); `status` are the chat statuses of docs/platform-agent/contracts.md §6, `who.kinds` who started a chat.
export default {
  title: 'Chats',
  new_chat: 'Nieuwe chat',
  note: {
    team: 'Alle chats op {{restaurant}}: die van jou, je team en het restaurant.',
    own: 'Jouw chats op {{restaurant}}.',
    // No restaurant selected (D18): the person's own chats started that way.
    no_restaurant:
      'Je chats zonder geselecteerd restaurant. Een chat verhuist naar de chats van een restaurant zodra je dat selecteert.',
  },
  log: 'Alle verzoeken in het Amigo-logboek',
  days: {
    today: 'Vandaag',
    yesterday: 'Gisteren',
    earlier: 'Eerder',
  },
  who: {
    you: 'Jij',
    kinds: {
      foodamigos: 'FoodAmigos',
      owner: 'Eigenaar',
      staff: 'Medewerker',
      partner: 'Partner',
    },
  },
  status: {
    done: 'Klaar',
    answered: 'Beantwoord',
    waiting: 'Wacht op goedkeuring',
    partial: '{{applied}} van {{total}} toegepast',
    rejected: 'Afgewezen',
    not_yet: 'Nog niet mogelijk',
    failed: 'Mislukt',
  },
  none: {
    title: 'Nog geen chats voor {{restaurant}}',
    title_no_restaurant: 'Nog geen chats zonder geselecteerd restaurant',
    text: 'Chats die je hier start, blijven hier, zodat je ze later kunt terugvinden.',
  },
  loading: 'Chats laden…',
  loading_more: 'Meer chats laden…',
  load_failed: 'De chats konden niet worden geladen.',
  retry: 'Opnieuw proberen',
  // A chat with answers the person hasn't read (QA45), before its last line.
  new_answers_one: 'Nieuw antwoord:',
  new_answers_other: 'Nieuwe antwoorden:',
};
